import { IMicro2DAppElement } from 'components/Micro2DApp';

// Returns the element to pass to `captureElementSnapshot` for a comparison
// download. The `<micro-2d-app>` host element is itself the composite
// container that holds both vehicles across all compare display modes
// (slider, side-by-side, firstCar, secondCar). Inner nodes like
// `compareViewerEl` are `display: none` outside slider mode and would
// produce a 0x0 canvas; `carouselCurrentSlideEl` only contains a single
// car. Capturing the host guarantees the download always shows both cars.
//
// All current callers are compare-mode only. The host is always visible in
// compare mode, but we still verify clientWidth/clientHeight to fail fast
// with a diagnostic instead of letting html-to-image silently emit a null
// blob on a zero-sized canvas.
export function getMicro2DAppCaptureTarget(el: IMicro2DAppElement): HTMLElement {
  const host = el as unknown as HTMLElement;
  if (host.clientWidth === 0 || host.clientHeight === 0) {
    throw new Error('Cannot capture <micro-2d-app>: host element has zero dimensions');
  }
  return host;
}
